<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter1">
<h1><a id="page_10"></a><a href="#/007toc#chapter1">ABOUT THIS BOOK</a></h1>
<p class="noindent">Simple, handcrafted details are at the heart of a beautiful wedding. Not only do they give intimacy and charm to the event, but the process of crafting a wedding together with family and friends, detail by detail, makes the big day all the more meaningful—and that much more of a cause for celebration!</p>
<p class="noindent">That said, it can be hard to know where to begin, what to focus on, and how to pull it all together. There are myriad details to plan, the disparate needs of guests and family members to attend to, and big (read: expensive!) decisions to make. But the creative potential is enormous.</p>
<p class="noindent">That’s why we’ve pooled our years of experience designing for, crafting, and styling weddings to write this book. In these pages, you’ll find a simple approach for breaking down the design of your wedding into manageable, enjoyable steps.</p>
<p class="noindent">We outline when and how to start, and we detail more than fifty timeless and iconic DIY projects in a variety of wedding styles with simple how-to instructions and practical tips for everything from how much time and money to budget to how to deploy eager helpers. Many of the projects require templates, which you can easily download from www.chroniclebooks.com/handmade-weddings and print out.</p>
<p class="noindent">In addition, we’ve scoured our Rolodexes for the very best resources that only the pros know about—from the best party rental companies to unexpected vendors who can produce fantastic wedding details on a budget.</p>
<p class="noindent">We’re excited to share these resources and ideas with you, many of which are wonderful not only for weddings but also for parties, showers, and even decorating your home. A good idea knows no bounds.</p>
<p class="noindent">We hope that this book helps demystify the process of planning and designing a fabulous event and helps you pull off the wedding of your dreams: a creative and personalized reflection of who you are and a fabulous party for your family and friends.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009chapter1.vue?2418db7b